export const menu = {
  menu_title: 'Resonance',
  menu_logOut: 'Déconnexion',
  menu_language_button_text: 'Changer',
  menu_languages_modal_title: 'Langages',
  menu_questionnaires_modal_title: 'Questionnaires',
}
